import { createGlobalStyle } from "styled-components";
import styled from "styled-components";

export const BasePageContainer = styled.div`
    height: 100vh;
`;

export const GlobalStyles = createGlobalStyle`

    * {
        font-family: 'Montserrat', sans-serif;
    }

    .mini-info {
        font-size: .8rem;
    }

    .info {
        font-size: 1rem;
    }

    .subtitle {
        font-size: 1.4rem;
    }

    .mx-3 {
        margin-left: 1rem;
        margin-right: 1rem;
    }

    .title {
        title: 2rem;
    }

    .w-100vw {
        width: 100vw;
    }

    .h-100vh {
        height: 100vh;
    }

    .bg-white {
        background-color: #fff;
    }

    .bg-sub {
        background-color: #364799;
    }


    .text-red {
        color: #EE4B21;
    }

    .text-grey {
        color: #ccc;
    }

    .text-white {
        color: #fff;
    }

    .text-darkgrey {
        color: #4d4d4d;
    }

    .text-uppercase {
        text-transform: uppercase;
    }

    .bg-lightgrey {
        background-color: #eee;
    }

    .h-88vh {
        min-height: 88vh
    }

    .icon-row {
        align-items: baseline;
    }

    body {
        //padding-bottom: 67.6px;
    }

    .color-icon-default {
        color: #cac6c6;
        font-size: 1.2rem;
    }

   .color-icon-default:hover {
        color: #EF4623;
    }

    .cursor-pointer {
        cursor: pointer;
    }

    .cursor-pointer:hover {
        opacity: 0.8;
    }
        
    .bg-lightblue {
        background-color: #30a7bf !important;
    }

`;
